import { Pencil, Trash2 } from "lucide-react";
import { money, tryValue } from "../lib/format";
import { fmtDisplay } from "../lib/currency";

const rateText = x => {
  if (x.currency === "TRY") return x.rate ? x.rate.toFixed(2) : "—";
  if (x.currency_rate) return `${x.currency_rate.toFixed(4)} TL`;
  return x.rate ? x.rate.toFixed(2) : "—";
};

export const TransactionRow = ({ tx, rate, currency, rates, can, picked, onPick, onTogglePaid, onEdit, onDelete }) => {
  const sign = tx.kind === "income" ? "+" : "−";
  const unpaid = tx.paid === false;

  return (
    <tr data-testid={`transaction-row-${tx.id}`} className={picked ? "row-picked" : ""}>
      <td className="pick-col">
        {onPick && (
          <input type="checkbox" data-testid={`pick-${tx.id}`} checked={!!picked} onChange={() => onPick(tx.id)}/>
        )}
      </td>
      <td>
        <span className={`type-pill ${tx.kind}`}>{tx.kind === "income" ? "Gelir" : "Gider"}</span>
        {tx.kind === "expense" && (
          <button type="button" className={`paid-pill ${unpaid ? "unpaid" : ""}`} data-testid={`paid-toggle-${tx.id}`}
            disabled={!can("edit")} title={can("edit") ? "Ödeme durumunu değiştir" : "Ödeme durumu"}
            onClick={() => onTogglePaid(tx)}>
            {unpaid ? "Ödenmedi" : "Ödendi"}
          </button>
        )}
      </td>
      <td>
        <b>{tx.description}</b>
        {tx.erp_state === "inactive" && <small className="sub-line" data-testid={`transaction-erp-inactive-${tx.id}`}>Kaynakta iptal / kaldırılmış — tutarı sıfırlandı</small>}
        {tx.recurring_id && <span className="recurring-badge" data-testid={`recurring-badge-${tx.id}`} title="Aylık tekrarlayan gider">↻ aylık</span>}
        {tx.kind === "income" && (
          <span className="account-tag" data-testid={`transaction-account-${tx.id}`}>{tx.account || "Atanmamış"}</span>
        )}
        {tx.kind === "income" && tx.gross_revenue != null && (
          <small className="sub-line">Ciro {money(tx.gross_revenue, tx.currency)}{tx.commission_rate != null ? ` · Komisyon %${tx.commission_rate}` : ""}</small>
        )}
      </td>
      <td><span className="group-tag">{tx.group}</span></td>
      <td>{tx.transaction_date}</td>
      <td><small>{rateText(tx)}</small></td>
      <td className={`right amount ${tx.kind}`}>{sign}{money(tx.amount, tx.currency)}</td>
      <td className={`right amount try-col ${tx.kind}`} data-testid={`transaction-try-${tx.id}`}>
        {sign}{fmtDisplay(tryValue(tx, rate), currency, rates)}
        {tx.currency !== "TRY" && <small className="sub-line">{tx.amount.toLocaleString("tr-TR")} {tx.currency} × {(tx.currency_rate || tx.rate || rate || 0).toFixed(4)}</small>}
      </td>
      <td className="row-actions">
        {can("edit") && (
          <button className="icon-btn" title="Düzenle" data-testid={`edit-transaction-${tx.id}`} onClick={() => onEdit(tx)}>
            <Pencil size={16}/>
          </button>
        )}
        {can("delete") && (
          <button className="icon-btn danger" title="Kaydı sil" data-testid={`delete-transaction-${tx.id}`} onClick={() => onDelete(tx)}>
            <Trash2 size={16}/>
          </button>
        )}
      </td>
    </tr>
  );
};
